var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseSquareSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 21.882 2.118 24 12 24C21.882 24 24 21.882 24 12C24 2.118 21.882 0 12 0C2.118 0 0 2.118 0 12ZM8.46452 8.46443C8.85505 8.07391 9.48821 8.07391 9.87874 8.46443L12.0001 10.5858L14.1214 8.46452C14.5119 8.074 15.145 8.074 15.5356 8.46452C15.9261 8.85505 15.9261 9.48821 15.5356 9.87874L13.4143 12L15.5356 14.1213C15.9261 14.5118 15.9261 15.145 15.5356 15.5355C15.1451 15.926 14.5119 15.926 14.1214 15.5355L12.0001 13.4142L9.87871 15.5356C9.48819 15.9261 8.85503 15.9261 8.4645 15.5356C8.07398 15.1451 8.07398 14.5119 8.4645 14.1214L10.5859 12L8.46452 9.87864C8.074 9.48812 8.074 8.85496 8.46452 8.46443Z",
    fill: "#FF8080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSquareSmall);
export default __webpack_public_path__ + "static/media/close-square-small.d962013697bcf43c98731e8071c454ed.svg";
export { ForwardRef as ReactComponent };